import { Box } from "@mui/system";
import React, { Component } from "react";
import MUISwitch from "../components/ui-components/toggleSwitch";

import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Button, Container, Divider, Grid, Paper, Stack } from "@mui/material";
import Progress from "../components/ui-components/graphs/Progress";
import PieGraph from "../components/ui-components/graphs/PieGraph";
import { getURLBase, updateParentHeight } from "../utils/helperFns";
import axios from "axios";

import wyzrTheme from "../styles/customTheme";
import { ChevronRightRounded, MoreHoriz } from "@mui/icons-material";
import TransactionList from "../components/ui-components/transactionList";
import { GradientButton } from "../components/ui-components/GradientButton";
import TransactionScreen from "../components/ui-components/transactionScreen";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import NightlifeIcon from "@mui/icons-material/Nightlife";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import LoaderBlock from "../components/ui-components/LoaderBlock";
import LoaderCard from "../components/ui-components/LoaderCard";

export class UpcomingWeeklySpends extends Component {
  constructor(props) {
    super(props);
    this.url = getURLBase(true) + "/upcomingspend";
    this.state = {
      isReady: null,
      amountPrefix: "£",
      spendingData: null,
      indexId: null,
      showAllTransaction: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    return { indexId: props?.indexId };
  }

  componentDidMount() {
    this.setState({ isReady: false }, () => {
      this.getData(this.state?.indexId);
    });
  }

  getData(indexId) {
    let stateToAdd = this.state;
    if (!stateToAdd.isReady) {
      axios.post(this.url, { gid: this.props.gid, indexId: indexId }).then((response) => {
        //console.log("UpcomingWeeklySpends getData RESPONSE --", response.data);
        stateToAdd.spendingData = response.data.body;
        stateToAdd.spendingData.currentViewisMoney = true;
        stateToAdd.isReady = true;
        stateToAdd.activeDate = indexId ? indexId : '1-10';
        stateToAdd.textdata = "£";
        if (stateToAdd.spendingData.currentViewisMoney) {
          stateToAdd = this.processData(stateToAdd.spendingData.data.moneyTab.pieData, stateToAdd);
        } else {
          stateToAdd = this.processData(stateToAdd.spendingData.data.footprintTab.pieData, stateToAdd);
        }
        this.setState(stateToAdd);
        console.log(this.state.spendingData, "<----- spending")
        //console.log("updated state for getData UpcomingWeeklySpends - ", stateToAdd);
      });
    }
  }

  processData = (response, currentState) => {
    let moreData = response;
    response = response.processData;
    let piedata = [];

    let d = new Map(Object.entries(response.debit));
    let c = new Map(Object.entries(response.credit));
    let total = 0;

    for (const [k, v] of c.entries()) {
      piedata.push({ name: k, value: v });
      total += v;
    }

    for (const [k, v] of d.entries()) {
      piedata.push({ name: k, value: v });
      total += v;
    }

    currentState.spendingData.piedata = piedata;
    currentState.spendingData.total = total;
    currentState.spendingData.moreData = moreData;
    return currentState;
  };


  componentDidCatch(error, errorInfo) {
    console.log("componentDidCatch - ", error, errorInfo);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.indexId !== this.state.indexId) {
      this.setState({ isReady: false, amountPrefix: "£" }, () => {
        this.getData(this.state?.indexId);
      });
    }
  }


  handleToggleChange = async () => {
    var s = this.state;
    s.spendingData.currentViewisMoney = !s.spendingData.currentViewisMoney
    if (s.spendingData.currentViewisMoney) {
      s = this.processData(this.state.spendingData.data.moneyTab.pieData, s);
      s.amountPrefix = "£";
    } else {
      s = this.processData(this.state.spendingData.data.footprintTab.pieData, s);
      s.amountPrefix = "kg";
    }
    this.setState(s)
  }



  render() {
    const WidgetData = () => {
      return (
        this.state.isReady ? (
          <Card className={"widgetCard cardShadow "}
            id="parent_UpcomingWeeklySpends">
            <Typography variant="h4" fontWeight={700} align="center" mx={"auto"} width="65%">
              {this.state?.spendingData?.currentViewisMoney
                ? "Upcoming Weekly Spends"
                : this.state?.spendingData?.data?.footprintTab?.tabHeading}
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              fontWeight="600"
              align="center"
              gutterBottom
            >
              {this.state?.spendingData?.currentViewisMoney
                ? this.state?.spendingData?.data?.moneyTab?.subHeading
                : this.state?.spendingData?.data?.footprintTab?.subHeading}
            </Typography>
            <Button sx={{
              margin: "0 auto",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							marginY: "0.5rem",
							marginTop: "-0.5rem",
							// fontSize: "0.7rem",
							padding: "2px"
            }}
              onClick={() => this.props.setEmbedUrl(this.state.spendingData.tutorial_iframe)}
            >
              See how this works <img src="/tutorial-icon.png" style={{ width: "35px", padding: "5px" }} />
            </Button>
            {this.state.isReady ? <Divider light /> : null}
            <CardContent textAlign="center" className={`${this.state?.spendingData?.currentViewisMoney === false ?
              this.state?.spendingData?.data?.moneyTab?.pieData?.total === null ?
                "blur" : "" :
              this.state?.spendingData?.data?.footprintTab?.pieData?.total === null ?
                "blur" :
                ""}`}>
              <Grid container>
                <Grid item md={6} sm={12} xs={12}>
                  <PieGraph
                    total={Math.round(this.state?.spendingData?.total * 100) / 100}
                    piedata={this.state?.spendingData?.piedata}
                    moreData={this.state?.spendingData?.moreData}
                    colors={["#eee", "#e96e66"]}
                  />
                  <Box p={2} pt={0} className={this.state?.isReady ? (this.state?.spendingData?.total <= 0 ? "blur" : "") : "null"}>
                    {this.state?.spendingData?.currentViewisMoney ? (
                      <Progress
                        width="100%"
                        prefix={" "}
                        startText={
                          this.state?.spendingData?.data?.moneyTab?.progressData?.startText
                        }
                        endText={this.state?.spendingData?.data?.moneyTab?.progressData?.endText}
                        startNumber={
                          this.state?.spendingData?.data?.moneyTab?.progressData?.startNumber
                        }
                        endNumber={
                          this.state?.spendingData?.data?.moneyTab?.progressData?.endNumber
                        }
                        color={
                          this.state?.spendingData?.data?.moneyTab?.progressData?.color ===
                            "error" &&
                            this.state?.spendingData?.data?.moneyTab?.progressData?.subcolor ===
                            "light"
                            ? wyzrTheme.palette.error.light
                            : this.state?.spendingData?.data?.moneyTab?.progressData?.color ===
                              "primary" &&
                              this.state?.spendingData?.data?.moneyTab?.progressData?.subcolor ===
                              "light"
                              ? wyzrTheme.palette.primary.light
                              : ""
                        }
                        subcolor={this.state?.spendingData?.data?.moneyTab?.progressData?.subcolor}
                      />
                    ) : (
                      <Progress
                        width="100%"
                        prefix={" "}
                        startText={
                          this.state?.spendingData?.data?.footprintTab?.progressData?.startText
                        }
                        endText={
                          this.state?.spendingData?.data?.footprintTab?.progressData?.endText
                        }
                        startNumber={
                          this.state?.spendingData?.data?.footprintTab?.progressData?.startNumber
                        }
                        endNumber={
                          this.state?.spendingData?.data?.footprintTab?.progressData?.endNumber
                        }
                        color={
                          this.state?.spendingData?.data?.moneyTab?.progressData?.color ===
                            "error" &&
                            this.state?.spendingData?.data?.moneyTab?.progressData?.subcolor ===
                            "light"
                            ? wyzrTheme.palette.error.light
                            : this.state?.spendingData?.data?.moneyTab?.progressData?.color ===
                              "primary" &&
                              this.state?.spendingData?.data?.moneyTab?.progressData?.subcolor ===
                              "light"
                              ? wyzrTheme.palette.primary.light
                              : ""
                        }
                        subcolor={
                          this.state?.spendingData?.data?.footprintTab?.progressData?.subcolor
                        }
                      />
                    )}
                  </Box>
                </Grid>
                <Grid md={6} sm={12} xs={12}>
                  <Grid>
                    <Paper variant="outlined" sx={{ borderColor: "grey.200" }}>
                      <Grid padding={2}>
                        <TransactionList
                          heading={
                            this.state?.spendingData?.currentViewisMoney
                              ? this.state?.spendingData?.data?.moneyTab?.transactions?.committed?.heading
                              : this.state?.spendingData?.data?.footprintTab?.transactions?.committed
                                ?.heading
                          }
                          transactionStatus={
                            this.state?.spendingData?.currentViewisMoney
                              ? (this.state?.spendingData?.data?.moneyTab?.progressData?.periodStatus === "past" ? "spent" : "upcoming") //this.state?.spendingData?.data?.moneyTab?.transactions?.committed?.transactionStatus
                              : (this.state?.spendingData?.data?.footprintTab?.progressData?.periodStatus === "past" ? "spent" : "upcoming") //this.state?.spendingData?.data?.footprintTab?.transactions?.committed?.transactionStatus
                          }
                          transactionDetails={
                            this.state?.spendingData?.currentViewisMoney
                              ? this.state?.spendingData?.data?.moneyTab?.transactions?.committed
                                ?.shorttransaction
                              : this.state?.spendingData?.data?.footprintTab?.transactions?.committed
                                ?.shorttransaction
                          }
                          prefix={this.state.amountPrefix}
                        />
                        {
                          this.state?.spendingData?.currentViewisMoney &&
                            this.state?.spendingData?.data?.moneyTab?.transactions?.committed
                              ?.shorttransaction.transactions.length ?
                            <Box textAlign="center" mt={2}>
                              <Button
                                variant="outlined"
                                fontWeight="800"
                                textTransformtype="capitalize"
                                onClick={this.props.toggleTransactionScreen}
                                endIcon={<ChevronRightRounded colorprimary />}
                              >
                                See More
                              </Button>
                            </Box> : !this.state?.spendingData?.currentViewisMoney &&
                              this.state?.spendingData?.data?.footprintTab?.transactions?.committed
                                ?.shorttransaction.transactions.length ?
                              <Box textAlign="center" mt={2}>
                                <Button
                                  variant="outlined"
                                  fontWeight="800"
                                  textTransformtype="capitalize"
                                  onClick={this.props.toggleTransactionScreen}
                                  endIcon={<ChevronRightRounded colorprimary />}
                                >
                                  See More
                                </Button>
                              </Box> : null
                        }

                        {
                          this.props.showAllTransaction ?
                            <TransactionScreen
                              toggleHandler={this.props.toggleTransactionScreen}
                              transactions={this.state?.spendingData?.currentViewisMoney ?
                                this.state?.spendingData?.data?.moneyTab?.transactions :
                                this.state?.spendingData?.data?.footprintTab?.transactions}
                              from_weekly_spends={true}
                              transactionStatus={this.state?.spendingData?.data?.moneyTab?.progressData?.periodStatus === "past" ? "spent" : "upcoming"}
                              prefix={this.state?.amountPrefix} /> : null
                        }
                      </Grid>
                    </Paper>
                  </Grid>

                  <Grid mt={2}>
                    <Paper variant="outlined" sx={{ borderColor: "grey.200" }}>
                      {
                        this.state?.spendingData?.currentViewisMoney ?

                          <Grid padding={2}>
                            <Grid container mb={1} justifyContent="space-between">
                              <Grid item>
                                <Typography gutterBottom variant="h6">
                                  Miscellaneous spends
                                </Typography>
                              </Grid>
                              <Grid item justifyContent={"end"}>

                                <Stack direction="row" spacing={1}>
                                  <ShoppingBagIcon fontSize="medium" />
                                  <FastfoodIcon fontSize="medium" />
                                  <NightlifeIcon fontSize="medium" />
                                  <LocalCafeIcon fontSize="medium" />
                                  <MoreHoriz fontSize="medium" />
                                </Stack>
                              </Grid>
                              <Container sx={{ display: "flex", alignItems: "center", justifyContent: "space-around", marginY: "10px", marginTop: '22px', marginLeft: "35px", marginRight: "35px", marginBottom: "-10px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                                  <Typography component="p" variant="body1" color="primary" gutterBottom fontWeight={900}>
                                    £ {this.state.spendingData?.data?.moneyTab.transactions.nonCommitted
                                      .shorttransaction.miscbudget}
                                  </Typography>
                                  <Typography component="p" variant="body1" sx={{ color: "darkgrey !important" }}  marginBottom="-0.2em">
                                    Budget
                                  </Typography>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                                  <Typography component="p" variant="body1" color="primary" gutterBottom fontWeight={900}>
                                    £ {this.state.spendingData?.data?.moneyTab.transactions.nonCommitted
                                      .shorttransaction.miscspent}
                                  </Typography>
                                  <Typography component="p" variant="body1" sx={{ color: "darkgrey !important" }}  marginBottom="-0.2em">
                                    Spent
                                  </Typography>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                                  <Typography component="p" variant="body1" color="primary" gutterBottom fontWeight={900}>
                                    £ {this.state.spendingData?.data?.moneyTab.transactions.nonCommitted
                                      .shorttransaction.miscremaining}
                                  </Typography>
                                  <Typography component="p" variant="body1" sx={{ color: "darkgrey !important" }}  marginBottom="-0.2em">
                                    Remaining
                                  </Typography>
                                </div>
                              </Container>
                            </Grid>
                          </Grid>
                          : <>
                            <Paper variant="outlined" sx={{ borderColor: "grey.200" }}>
                              <Grid padding={2}>
                                <TransactionList
                                  showNoDataMessage={true}
                                  heading={this.state.spendingData?.data?.footprintTab.transactions.nonCommitted.heading}
                                  transactionStatus={this.state.spendingData?.data?.footprintTab.transactions.nonCommitted.transactionStatus}
                                  transactionDetails={this.state.spendingData?.data?.footprintTab.transactions.nonCommitted.shorttransaction}
                                  prefix={this.state.amountPrefix}
                                />
                              </Grid>
                            </Paper>
                          </>
                      }
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>)
          :
          <LoaderCard title={"Loading Data"} />
      )
    };

    return (
      <Box sx={{ position: "relative", width: "100%" }}>
        <Box sx={{ position: "absolute", top: 0, right: 2, zIndex: 1 }}>
          <MUISwitch checked={this.state.amountPrefix == "£" ? false : true} handleClick={this.handleToggleChange} />
        </Box>
        <WidgetData />
      </Box>
    );
  }
}

export default UpcomingWeeklySpends;
